import { useState, useEffect } from "react";
import ENDPOINTS from "@/lib/endpoints";

// Module-level cache — one fetch shared across all components
let cached = null;
let pending = null;

export function useMarqueeData() {
  const [marqueeContent, setMarqueeContent] = useState(cached);

  useEffect(() => {
    if (cached !== null) {
      setMarqueeContent(cached);
      return;
    }

    if (!pending) {
      const baseUrl = (process.env.NEXT_PUBLIC_API_URL || "").replace(/\/$/, "");
      pending = fetch(`${baseUrl}${ENDPOINTS.MARQUEE_DATA}`)
        .then((res) => res.json())
        .then((data) => {
          const elements = data?.data?.elements;
          const message = Array.isArray(elements) && elements.length > 0
            ? elements[0]?.message ?? ""
            : "";
          cached = message;
          return cached;
        })
        .catch(() => {
          cached = "";
          return cached;
        })
        .finally(() => {
          pending = null;
        });
    }

    pending.then((content) => setMarqueeContent(content));
  }, []);

  return marqueeContent || "";
}
